<template>
  <q-btn
    v-if="isVisible"
    id="intercom-share"
    outline
    no-caps
    :to="{
      name: 'Edit Property Report',
      params: { reportId: report.id },
      query: { initialStep: 'report-settings' }
    }"
  >
    <q-icon v-if="showIcon" :name="shareIcon" size="medium" class="q-mr-sm" />
    <span v-if="$q.screen.gt.sm">Share</span>
  </q-btn>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { type AccessUser, type PropertyReportSubscriptionAttributes } from 'common'

import { useUserStore } from '@/stores/user'

export default {
  name: 'ButtonShare',
  props: {
    report: {
      type: Object as PropType<PropertyReportSubscriptionAttributes | null>,
      default: null
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      peopleWithAccess: [] as AccessUser[]
    }
  },
  computed: {
    isVisible() {
      if (this.report) {
        return useUserStore().organizationMembers.some((_) => _.id === this.report?.user_id)
      }
      return false
    },
    shareIcon() {
      return this.peopleWithAccess.length < 2 ? 'share' : 'group'
    },
    organizationMembers() {
      return useUserStore().organizationMembers
    }
  },
  created() {
    const user = this.organizationMembers.find((_) => _.id === this.$auth0.user.value?.sub)
    if (this.report && user?.id) {
      this.peopleWithAccess.push(...this.report.access_users)
      if (this.report.user_id === user.id) {
        this.peopleWithAccess.push(user)
      }
    }
  }
}
</script>
